import '../batman/survey-list/batman-survey-list1.js'
(function () {
  new Batman('surveyList', 'surveyList');
})();